import React from "react"
import "bootstrap/dist/css/bootstrap.min.css"

import { Link } from "gatsby"
import { Container, Row, Col, Image } from "react-bootstrap"
import { Helmet } from "react-helmet"
import SolutionCard from "../../components/SolutionCard"
import TRAVEL_GUIDE from "../../../assets/images/travel-guide.png"
import QualityControlModal from "../../components/QualityControlModal"
import Header from "../../components/Header"
import Footer from "../../components/Footer"
import NewsCard from "../../components/NewsCard"
import PatentsCard from "../../components/PatentsCard"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import Slider from "react-slick"
import { useGlobalState } from "../../global/global"
import { getLanguageFile } from "../../global/langauge.helper"
import CUBES from "../../../assets/images/careerDetailCubes.png"
import ECEM_BATU from "../../../assets/images/ECEM_BATU.jpeg"
import OMER_EMIR_CAGO_HAVELSAN from "../../../assets/images/OMER_EMIR_CAGO_HAVELSAN.jpeg"
import ERDAL_BULGARISTAN from "../../../assets/images/ERDAL_BULGARISTAN.jpeg"
import trademark_adam_staff from "../../../assets/images/trademark_adam_staff.png"
import trademark_arts from "../../../assets/images/trademark_arts.png"
import trademark_batp from "../../../assets/images/trademark_batp.png"
import trademark_hymots from "../../../assets/images/trademark_hymots.png"
import trademark_nginr from "../../../assets/images/trademark_nginr.png"
import trademark_etecube from "../../../assets/images/trademark_etecube.png"
// import trademark_sama_isr from "../../../assets/images/trademark_sama_isr.png"

import "./styles.scss"

const AboutUsPage = () => {
  const [state] = useGlobalState()

  const [showModal, setShowModal] = React.useState(false)

  const sliderSettings = {
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1450,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  }
  return (
    <Container fluid className="main-container">
      <div className="application">
        <Helmet title={getLanguageFile(state.language).Title.aboutUs}>
          <meta charSet="utf-8" />
        </Helmet>
      </div>
      <Header />
      <Container fluid className="about-us-image-container">
        <Image className={"about-us-image-background"} src={CUBES} />
      </Container>
      <Container
        fluid
        className="about-us-first-section d-flex align-items-center"
      >
        <Container className="about-us-introduction-container">
          <Row>
            <Col className={"about-us-introduction-texts-col col-lg-8 col-10"}>
              <Row>
                <h2 className="about-us-ceo-description-title">
                  {getLanguageFile(state.language).AboutUs.ceoDescriptionTitle}
                </h2>
              </Row>
              <Row>
                <p className="about-us-ceo-description">
                  {getLanguageFile(state.language).AboutUs.ceoDescription}
                </p>
              </Row>
            </Col>
          </Row>
        </Container>
      </Container>
      <Container>
        <SolutionCard
          solutionImg={TRAVEL_GUIDE}
          solutionTitle={
            <h2
              onClick={() => setShowModal(true)}
              className="qualityControlPopupText"
            >
              {getLanguageFile(state.language).AboutUs.qualityPolicy}
            </h2>
          }
        />
      </Container>
      <h2 className="patents-header-text">
        {getLanguageFile(state.language).AboutUs.trademarks}
      </h2>
      <Container className="patents">
        <PatentsCard
          newsImg={trademark_adam_staff}
          newsDescription={
            <>
              adam STAFF<sup>®</sup>
            </>
          }
          patent={"TrademarkAdamStaff.pdf"}
        />
        <PatentsCard
          newsImg={trademark_arts}
          newsDescription={
            <>
              arts<sup>®</sup>
            </>
          }
          patent={"TrademarkArts.pdf"}
        />
        <PatentsCard
          newsImg={trademark_batp}
          newsDescription={
            <>
              batP<sup>®</sup>
            </>
          }
          patent={"Trademarkbatp.pdf"}
        />
        <PatentsCard
          newsImg={trademark_hymots}
          newsDescription={
            <>
              hymots<sup>®</sup>
            </>
          }
          patent={"TrademarkHymots.pdf"}
        />
        <PatentsCard
          newsImg={trademark_nginr}
          newsDescription={
            <>
              nginr<sup>®</sup>
            </>
          }
          patent={"TrademarkNGINR.pdf"}
        />
        <PatentsCard
          newsImg={trademark_etecube}
          newsDescription={
            <>
              etecube<sup>®</sup>
            </>
          }
          patent={"TrademarkEtecube.pdf"}
        />
        {/* <PatentsCard
          newsImg={trademark_sama_isr}
          newsDescription={"samaISR"}
          patent={"PatentSamaISR.pdf"}
        /> */}
      </Container>
      <Container fluid className="news-container">
        <h2 className="news-heading-text">
          {getLanguageFile(state.language).AboutUs.news}
        </h2>

        <Slider style={{ width: "70%" }} {...sliderSettings}>
          <NewsCard
            newsImg={ECEM_BATU}
            goTo="https://www.linkedin.com/feed/update/urn:li:activity:7400154444069322752/"
            newsDescription={getLanguageFile(state.language).AboutUs.ecemBatu}
          />
          <NewsCard
            newsImg={OMER_EMIR_CAGO_HAVELSAN}
            goTo="https://www.linkedin.com/feed/update/urn:li:activity:7397272521869496320/"
            newsDescription={getLanguageFile(state.language).AboutUs.omerCago}
          />
          <NewsCard
            newsImg={ERDAL_BULGARISTAN}
            goTo="https://www.linkedin.com/feed/update/urn:li:activity:7399693259838734336/"
            newsDescription={
              getLanguageFile(state.language).AboutUs.erdalBulgar
            }
          />
        </Slider>
        <Link to={"https://www.linkedin.com/company/etesolutions/"}>
          <h2 className="view-all-text">
            {getLanguageFile(state.language).AboutUs.viewAllNews}
          </h2>
        </Link>
      </Container>
      <Footer extraStyle={{ zIndex: 9999, backgroundColor: "white" }} />
      <QualityControlModal
        showModal={showModal}
        state={state}
        getLanguageFile={getLanguageFile}
        onHide={() => setShowModal(false)}
      />
    </Container>
  )
}

export default AboutUsPage
